import React, { useEffect, useRef, useState } from "react";
import { FONT_FAMILY } from "../../reportProperties/constants";
import NumberFormat from "react-number-format";
import reactCSS from "reactcss";
import { SketchPicker } from "react-color";
import ReactSelect from "react-select";
import { useSelector } from "react-redux";

const TileCustomHeading = ({ setHeadingStyleData, headingStyleData, chartView, isCustomTypeHeading = false, error = {}, viewOnly = false ,className=""}) => {
    const {
        dropDownList: { fonts: FONT_FAMILY }
    } = useSelector(state => state?.reportPropertyReducer);
    const options = [
        { value: "Heading 1", label: "Heading 1" },
        { value: "Heading 2", label: "Heading 2" },
        { value: "Heading 3", label: "Heading 3" }
    ];
    const fontFamilyOptions = FONT_FAMILY?.map(f => ({ value: f.id, label: f.name }));
    const boldOptions = [
        { value: true, label: "Yes" },
        { value: false, label: "No" }
    ];
    const alignmentOptions = [
        { value: "left", label: "Left" },
        { value: "center", label: "Center" },
        { value: "right", label: "Right" }
    ];
    const styles = reactCSS({
        default: {
            color: {
                width: "40px",
                height: "15px",
                borderRadius: "3px",
                background: headingStyleData?.[chartView]?.color,
                zoom: "107%"
            },
            popover: {
                position: "absolute",
                zIndex: "3",
                left: "111px",
                top: "-76px"
            },
            cover: {
                position: "fixed",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px"
            },
            swatch: {
                padding: "6px",
                background: "#ffffff",
                borderRadius: "2px",
                cursor: "pointer",
                display: "inline-block",
                boxShadow: "0 0 0 1px rgba(0,0,0,.2)"
            }
        }
    });
    const pickerRefs = useRef({
        bgColor: null,
        fontColor: null
    });

    const dropdownRefs = useRef({
        bgColor: null,
        fontColor: null
    });
    const [pickersState, setPickersState] = useState({
        bgColor: false,
        bgColor: false
    });

    useEffect(() => {
        const handleClickOutside = event => {
            for (let key in pickerRefs.current) {
                const pickerRef = pickerRefs.current[key];
                const dropdownRef = dropdownRefs.current[key];
                if (pickerRef && !pickerRef.contains(event.target) && dropdownRef && !dropdownRef.contains(event.target)) {
                    setPickersState(prevState => ({
                        ...prevState,
                        [key]: false
                    }));
                }
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const togglePicker = picker => {
        setPickersState(prevState => ({
            ...prevState,
            [picker]: !prevState[picker]
        }));
    };
    const handleheadingDataChange = ({ name, value }) => {
        setHeadingStyleData(prevValue => {
            return {
                ...prevValue,
                [chartView]: {
                    ...prevValue?.[chartView],
                    [name]: value
                }
            };
        });
    };
    return (
        <div className="col-md-12 main-sec accord-smart-section">
            <div className="form-row outer-font-section">
                <div className="style-outer">
                    <div className="styles-box">
                        <div className="styles-sec">
                            <div className={`d-flex f-outer`}>
                                <div className="form-row col-12 pr-0">
                                    <div className={`form-group col-12 mt-2 mb-2 label-name ${className}`}>
                                        <label>Name *</label>
                                        <input
                                            type="text"
                                            placeholder="Name"
                                            class={`form-control ${error?.[chartView] ? "error-border" : ""}${viewOnly ? "cursor-disabled" : ""}`}
                                            value={headingStyleData?.[chartView]?.name}
                                            onChange={e => {
                                                let value = e.target.value;
                                                setHeadingStyleData(prevParams => {
                                                    return {
                                                        ...prevParams,
                                                        [chartView]: {
                                                            ...prevParams?.[chartView],
                                                            name: value
                                                        }
                                                    };
                                                });
                                            }}
                                            disabled={viewOnly}
                                        />
                                    </div>
                                </div>
                                {!isCustomTypeHeading?.[chartView] ? (
                                    <div className={`font-family font-st col-md-12 `}>
                                        <label>Heading Style *</label>
                                        <ReactSelect
                                            className={`dropdown${viewOnly ? "cursor-disabled" : ""}`}
                                            options={options}
                                            value={options.find(option => option.value === headingStyleData?.[chartView]?.heading_style)}
                                            onChange={selectedOption =>
                                                handleheadingDataChange({
                                                    name: "heading_style",
                                                    value: selectedOption?.value
                                                })
                                            }
                                            placeholder="Select Heading"
                                            classNamePrefix="select-ft-family"
                                            isDisabled={viewOnly}
                                        />
                                    </div>
                                ) : (
                                    <>
                                        <div className={`font-family font-st col-md-6 `}>
                                            <label>Font Name</label>
                                            <div className="font-select">
                                                <ReactSelect
                                                    className={`dropdown${viewOnly ? "cursor-disabled" : ""}`}
                                                    value={
                                                        fontFamilyOptions?.find(option => option.value === headingStyleData?.[chartView]?.font_id) ||
                                                        null
                                                    }
                                                    onChange={selectedOption =>
                                                        handleheadingDataChange({ name: "font_id", value: selectedOption?.value })
                                                    }
                                                    options={fontFamilyOptions}
                                                    placeholder="Select Font"
                                                    isDisabled={viewOnly}
                                                />
                                            </div>
                                        </div>
                                        <div className={`font-size font-st col-md-6`}>
                                            <label>Font Size </label>
                                            <div className={`input-ft-size`}>
                                                <NumberFormat
                                                    value={headingStyleData?.[chartView]?.font_size}
                                                    onValueChange={values =>
                                                        handleheadingDataChange({
                                                            name: "font_size",
                                                            value: values.floatValue
                                                        })
                                                    }
                                                    allowNegative={false}
                                                    suffix=" Pt"
                                                    className={`${viewOnly ? "cursor-disabled" : ""}`}
                                                    disabled={viewOnly}
                                                />
                                            </div>
                                        </div>
                                        <div className={`font-color font-st col-md-6 `}>
                                            <label>Font Color </label>
                                            <div className={`dropdown`} ref={el => (dropdownRefs.current.fontColor = el)}>
                                                <div
                                                    className="dropdown-toggle"
                                                    type="button"
                                                    onClick={() => {
                                                        !viewOnly && togglePicker("fontColor");
                                                    }}
                                                >
                                                    <span>{headingStyleData?.[chartView]?.color || "Select"}</span>
                                                    <span
                                                        className="color-bx"
                                                        style={{
                                                            background: headingStyleData?.[chartView]?.color
                                                                ? `#${headingStyleData?.[chartView]?.color}`
                                                                : "#fff"
                                                        }}
                                                    ></span>
                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                </div>
                                                {pickersState?.fontColor && (
                                                    <div
                                                        ref={el => (pickerRefs.current.fontColor = el)}
                                                        style={{ ...styles.popover, pointerEvents: "auto" }}
                                                        className="color-picker-container"
                                                    >
                                                        <div style={{ ...styles.cover, pointerEvents: "none" }} />
                                                        <SketchPicker
                                                            position="right"
                                                            color={headingStyleData?.[chartView]?.color||""}
                                                            presetColors={[
                                                                "#ffe242",
                                                                "#ffa105",
                                                                "#ff0305",
                                                                "#0018A8",
                                                                "#800080",
                                                                "#3E8EDE",
                                                                "#417505",
                                                                "#ffffff"
                                                            ]}
                                                            onChange={color =>
                                                                handleheadingDataChange({
                                                                    name: "color",
                                                                    value: color.hex?.replace("#", "")
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className={`font-family font-st col-md-6 `}>
                                            <label>Font Bold</label>
                                            <div className="font-select">
                                                <ReactSelect
                                                    className={`dropdown${viewOnly ? "cursor-disabled" : ""}`}
                                                    value={boldOptions?.find(option => option.value === headingStyleData?.[chartView]?.bold) || null}
                                                    onChange={selectedOption =>
                                                        handleheadingDataChange({ name: "bold", value: selectedOption?.value })
                                                    }
                                                    options={boldOptions}
                                                    placeholder="Select"
                                                    isDisabled={viewOnly}
                                                />
                                            </div>
                                        </div>
                                        <div className={`font-color font-st col-md-6 `}>
                                            <label>Background Color</label>
                                            <div className={`dropdown`} ref={el => (dropdownRefs.current.bgColor = el)}>
                                                <div
                                                    className={`dropdown-toggle ${viewOnly ? "cursor-disabled" : ""}`}
                                                    type="button"
                                                    onClick={() => !viewOnly && togglePicker("bgColor")}
                                                >
                                                    <span>{headingStyleData?.[chartView]?.bg_color || "Select"}</span>
                                                    <span
                                                        className="color-bx"
                                                        style={{
                                                            background: headingStyleData?.[chartView]?.bg_color
                                                                ? `#${headingStyleData?.[chartView]?.bg_color}`
                                                                : "#fff"
                                                        }}
                                                    ></span>
                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                </div>
                                                {pickersState?.bgColor && (
                                                    <div
                                                        ref={el => (pickerRefs.current.bgColor = el)}
                                                        style={{ ...styles.popover, pointerEvents: "auto" }}
                                                        className="color-picker-container"
                                                    >
                                                        <div style={{ ...styles.cover, pointerEvents: "none" }} />
                                                        <SketchPicker
                                                            position="right"
                                                            color={headingStyleData?.[chartView]?.bg_color||""}
                                                            presetColors={[
                                                                "#95cd50",
                                                                "#ffe242",
                                                                "#ffa105",
                                                                "#ff0305",
                                                                "#0018A8",
                                                                "#003f2d",
                                                                "#3E8EDE",
                                                                "#417505"
                                                            ]}
                                                            onChange={bg_color =>
                                                                handleheadingDataChange({
                                                                    name: "bg_color",
                                                                    value: bg_color.hex?.replace("#", "")
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className={`font-family font-st col-md-6 `}>
                                            <label>Alignment</label>
                                            <div className="font-select">
                                                <ReactSelect
                                                    className={`dropdown${viewOnly ? "cursor-disabled" : ""}`}
                                                    value={
                                                        alignmentOptions?.find(option => option.value === headingStyleData?.[chartView]?.alignment) ||
                                                        null
                                                    }
                                                    onChange={selectedOption =>
                                                        handleheadingDataChange({ name: "alignment", value: selectedOption?.value })
                                                    }
                                                    options={alignmentOptions}
                                                    placeholder="Select"
                                                    isClearable
                                                    isDisabled={viewOnly}
                                                />
                                            </div>
                                        </div>
                                        {["top", "left", "right", "bottom"].map(side => (
                                            <div key={side} className={`font-size font-st col-md-6`}>
                                                <label>Margin {side.charAt(0).toUpperCase() + side.slice(1)}</label>
                                                <div className={`input-ft-size`}>
                                                    <NumberFormat
                                                        value={headingStyleData?.[chartView]?.cell_margin?.[side]}
                                                        onValueChange={values => {
                                                            handleheadingDataChange({
                                                                name: `cell_margin`,
                                                                value: {
                                                                    ...headingStyleData?.[chartView]?.cell_margin,
                                                                    [side]: values.floatValue
                                                                }
                                                            });
                                                        }}
                                                        allowNegative={false}
                                                        suffix=" inch"
                                                        className={`${viewOnly ? "cursor-disabled" : ""}`}
                                                        disabled={viewOnly}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TileCustomHeading;
